import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  Button,
} from '@mui/material';
import {useParams} from 'react-router-dom';
import React from 'react';
import {useSnackbar} from 'notistack';
import {useAddMiniSiteCategoryMutation, useGetCompanyProductsQuery} from 'api';
import MiniSiteCategoryForm from './MiniSiteCategoryForm';

function CreateMiniSiteCategoryModal({open, onClose}) {
  const {id} = useParams();
  const {data, isLoading, isError} = useGetCompanyProductsQuery(id);
  const formRef = React.useRef();
  const [addMiniSiteCategory] = useAddMiniSiteCategoryMutation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();
  return (
    <Dialog fullWidth scroll="body" maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle mb={2} variant="h6">
        Create Category
      </DialogTitle>
      <DialogContent>
        <MiniSiteCategoryForm
          disabled={isLoading || isError}
          ref={formRef}
          products={data?.data}
          onSubmit={async (values, actions) => {
            try {
              setIsSubmitting(true);
              const newObj = {
                ...values,
                companyId: id,
              };
              await addMiniSiteCategory(newObj).unwrap();
              actions.resetForm();
              enqueueSnackbar('MiniSiteCategory created successfully', {
                variant: 'success',
              });
              onClose();
            } catch (e) {
              const message =
                e.status === 400 ? e.MiniSiteCategoryResponse?.details?.[0]?.message : undefined;
              enqueueSnackbar(message || 'Failed to create MiniSiteCategory', {
                variant: 'error',
              });
            } finally {
              setIsSubmitting(false);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={isSubmitting} color="inherit" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          endIcon={isSubmitting ? <CircularProgress ml={2} size={16} /> : null}
          disabled={isSubmitting}
          color="primary"
          variant="contained"
          onClick={() => formRef.current?.submit?.()}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateMiniSiteCategoryModal;
